const MOBILE_QUERY = "(max-width: 767.98px)";
const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

export function getClientPerformanceProfile() {
   if (typeof window === "undefined") {
      return {
         isLowPower: false,
         isMobile: false,
         prefersReducedMotion: false,
         renderFrameMultiplier: 1,
      };
   }

   const nav = window.navigator || {};
   const connection = nav.connection || nav.mozConnection || nav.webkitConnection;
   const cores = nav.hardwareConcurrency || 8;
   const memory = nav.deviceMemory || 8;
   const isMobile = window.matchMedia?.(MOBILE_QUERY).matches || false;
   const coarsePointer = window.matchMedia?.("(pointer: coarse)").matches || false;
   const prefersReducedMotion =
      window.matchMedia?.(REDUCED_MOTION_QUERY).matches || false;
   const saveData = Boolean(connection?.saveData);

   const isLowPower =
      prefersReducedMotion ||
      saveData ||
      cores <= 4 ||
      memory <= 4 ||
      (isMobile && cores <= 6) ||
      (coarsePointer && memory <= 6);

   return {
      isLowPower,
      isMobile,
      prefersReducedMotion,
      saveData,
      cores,
      memory,
      renderFrameMultiplier: isLowPower ? (isMobile ? 1.7 : 1.4) : 1,
   };
}

export function subscribeToPerformanceChanges(callback) {
   if (typeof window === "undefined") return () => {};

   const mediaQueries = [
      window.matchMedia?.(MOBILE_QUERY),
      window.matchMedia?.(REDUCED_MOTION_QUERY),
      window.matchMedia?.("(pointer: coarse)"),
   ].filter(Boolean);
   const connection =
      window.navigator?.connection ||
      window.navigator?.mozConnection ||
      window.navigator?.webkitConnection;

   mediaQueries.forEach((query) => query.addEventListener?.("change", callback));
   connection?.addEventListener?.("change", callback);

   return () => {
      mediaQueries.forEach((query) =>
         query.removeEventListener?.("change", callback),
      );
      connection?.removeEventListener?.("change", callback);
   };
}
